import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, resolveComponent as _resolveComponent, createVNode as _createVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, vModelText as _vModelText, withDirectives as _withDirectives } from "vue"

const _hoisted_1 = { class: "row q-pb-lg" }
const _hoisted_2 = /*#__PURE__*/_createElementVNode("div", { class: "col-2" }, null, -1)
const _hoisted_3 = {
  class: "col text-primary no-padding",
  style: {"font-size":"27px"}
}
const _hoisted_4 = /*#__PURE__*/_createElementVNode("div", { class: "col-2" }, null, -1)
const _hoisted_5 = { class: "row q-pb-lg" }
const _hoisted_6 = /*#__PURE__*/_createElementVNode("div", { class: "col-2" }, null, -1)
const _hoisted_7 = { class: "col no-padding" }
const _hoisted_8 = /*#__PURE__*/_createElementVNode("div", { class: "col-2" }, null, -1)
const _hoisted_9 = { class: "row" }
const _hoisted_10 = /*#__PURE__*/_createElementVNode("div", { class: "col-2" }, null, -1)
const _hoisted_11 = {
  class: "col-3 q-mt-md Rotis text-white bg-secondary",
  align: "center",
  style: {"height":"45px"}
}
const _hoisted_12 = { class: "q-pt-sm" }
const _hoisted_13 = /*#__PURE__*/_createElementVNode("div", {
  class: "row",
  style: {"height":"30px"}
}, [
  /*#__PURE__*/_createElementVNode("div", { class: "col" })
], -1)
const _hoisted_14 = { class: "row q-pt-md" }
const _hoisted_15 = /*#__PURE__*/_createElementVNode("div", { class: "col-2" }, null, -1)
const _hoisted_16 = { class: "col bg-grey text-grey" }
const _hoisted_17 = /*#__PURE__*/_createElementVNode("div", { class: "col-2" }, null, -1)
const _hoisted_18 = { class: "row q-pt-md" }
const _hoisted_19 = /*#__PURE__*/_createElementVNode("div", { class: "col-2" }, null, -1)
const _hoisted_20 = { class: "col no-padding" }
const _hoisted_21 = { class: "column bordered" }
const _hoisted_22 = { class: "col" }
const _hoisted_23 = ["onClick"]
const _hoisted_24 = {
  class: "col-6",
  align: "left"
}
const _hoisted_25 = /*#__PURE__*/_createElementVNode("div", {
  class: "col-6",
  align: "right"
}, "X", -1)
const _hoisted_26 = /*#__PURE__*/_createElementVNode("div", { class: "col-2" }, null, -1)
const _hoisted_27 = { class: "row q-pt-md" }
const _hoisted_28 = /*#__PURE__*/_createElementVNode("div", { class: "col-2" }, null, -1)
const _hoisted_29 = { class: "col no-padding" }
const _hoisted_30 = { class: "column" }
const _hoisted_31 = { class: "col" }
const _hoisted_32 = { class: "row" }
const _hoisted_33 = { class: "col no-padding" }
const _hoisted_34 = /*#__PURE__*/_createElementVNode("div", { class: "middleSection" }, null, -1)
const _hoisted_35 = { class: "col no-padding" }
const _hoisted_36 = { class: "col" }
const _hoisted_37 = { class: "row" }
const _hoisted_38 = /*#__PURE__*/_createElementVNode("div", { class: "middleSection bg-white" }, null, -1)
const _hoisted_39 = /*#__PURE__*/_createElementVNode("div", { class: "col-2" }, null, -1)
const _hoisted_40 = { class: "row q-pt-md" }
const _hoisted_41 = /*#__PURE__*/_createElementVNode("div", { class: "col-2" }, null, -1)
const _hoisted_42 = { class: "col no-padding" }
const _hoisted_43 = { class: "column" }
const _hoisted_44 = { class: "col no-padding" }
const _hoisted_45 = { class: "col" }
const _hoisted_46 = /*#__PURE__*/_createElementVNode("div", { class: "col-2" }, null, -1)
const _hoisted_47 = { class: "row q-pt-md" }
const _hoisted_48 = /*#__PURE__*/_createElementVNode("div", { class: "col-2" }, null, -1)
const _hoisted_49 = { class: "col no-padding" }
const _hoisted_50 = { class: "column" }
const _hoisted_51 = { class: "col" }
const _hoisted_52 = { class: "row" }
const _hoisted_53 = { class: "no-padding col" }
const _hoisted_54 = /*#__PURE__*/_createElementVNode("div", { class: "middleSection" }, null, -1)
const _hoisted_55 = { class: "no-padding col" }
const _hoisted_56 = { class: "col" }
const _hoisted_57 = { class: "row" }
const _hoisted_58 = /*#__PURE__*/_createElementVNode("div", { class: "middleSection bg-white" }, null, -1)
const _hoisted_59 = /*#__PURE__*/_createElementVNode("div", { class: "col-2" }, null, -1)
const _hoisted_60 = { class: "row q-pt-md" }
const _hoisted_61 = /*#__PURE__*/_createElementVNode("div", { class: "col-2" }, null, -1)
const _hoisted_62 = { class: "col no-padding" }
const _hoisted_63 = { class: "column" }
const _hoisted_64 = { class: "col no-padding" }
const _hoisted_65 = { class: "col" }
const _hoisted_66 = /*#__PURE__*/_createElementVNode("div", { class: "col-2" }, null, -1)
const _hoisted_67 = { class: "row q-pt-md" }
const _hoisted_68 = /*#__PURE__*/_createElementVNode("div", { class: "col-2" }, null, -1)
const _hoisted_69 = { class: "col no-padding" }
const _hoisted_70 = { class: "column" }
const _hoisted_71 = { class: "col no-padding" }
const _hoisted_72 = { class: "col" }
const _hoisted_73 = /*#__PURE__*/_createElementVNode("div", { class: "col-2" }, null, -1)
const _hoisted_74 = { class: "row q-pt-md" }
const _hoisted_75 = /*#__PURE__*/_createElementVNode("div", { class: "col-2" }, null, -1)
const _hoisted_76 = { class: "col no-padding" }
const _hoisted_77 = { class: "column" }
const _hoisted_78 = { class: "col no-padding" }
const _hoisted_79 = { class: "col" }
const _hoisted_80 = /*#__PURE__*/_createElementVNode("div", { class: "col-2" }, null, -1)

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_GreenTitle = _resolveComponent("GreenTitle")!

  return (_openBlock(), _createElementBlock("div", null, [
    _createElementVNode("div", _hoisted_1, [
      _hoisted_2,
      _createElementVNode("div", _hoisted_3, _toDisplayString(_ctx.$t('Compatibility.CompatibilityRequest.PresentationSection.Title')), 1),
      _hoisted_4
    ]),
    _createElementVNode("div", _hoisted_5, [
      _hoisted_6,
      _createElementVNode("div", _hoisted_7, _toDisplayString(_ctx.$t('Compatibility.CompatibilityRequest.PresentationSection.Resume')), 1),
      _hoisted_8
    ]),
    _createVNode(_component_GreenTitle, {
      title: _ctx.$t('Compatibility.CompatibilityRequest.CarrierSolution')
    }, null, 8, ["title"]),
    _createElementVNode("div", _hoisted_9, [
      _hoisted_10,
      _createElementVNode("div", _hoisted_11, [
        _createElementVNode("div", _hoisted_12, _toDisplayString(_ctx.transport.name), 1)
      ])
    ]),
    _hoisted_13,
    _createVNode(_component_GreenTitle, {
      title: _ctx.$t('Compatibility.CompatibilityRequest.DrugAdditive')
    }, null, 8, ["title"]),
    _createElementVNode("div", _hoisted_14, [
      _hoisted_15,
      _createElementVNode("div", _hoisted_16, _toDisplayString(_ctx.$t('Compatibility.CompatibilityRequest.DrugAdditiveSubText')), 1),
      _hoisted_17
    ]),
    _createElementVNode("div", _hoisted_18, [
      _hoisted_19,
      _createElementVNode("div", _hoisted_20, [
        _createElementVNode("div", _hoisted_21, [
          _createElementVNode("div", _hoisted_22, [
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.tabOfSelectedMeds, (Med) => {
              return (_openBlock(), _createElementBlock("div", {
                class: "row",
                key: Med.id
              }, [
                _createElementVNode("button", {
                  class: "row col mybutton",
                  "no-caps": "",
                  flat: "",
                  rounded: "",
                  onClick: ($event: any) => (_ctx.removeMedsByMed(Med))
                }, [
                  _createElementVNode("div", _hoisted_24, _toDisplayString(Med.handelsname), 1),
                  _hoisted_25
                ], 8, _hoisted_23)
              ]))
            }), 128))
          ])
        ])
      ]),
      _hoisted_26
    ]),
    _createElementVNode("div", _hoisted_27, [
      _hoisted_28,
      _createElementVNode("div", _hoisted_29, [
        _createElementVNode("div", _hoisted_30, [
          _createElementVNode("div", _hoisted_31, [
            _createElementVNode("div", _hoisted_32, [
              _createElementVNode("div", _hoisted_33, _toDisplayString(_ctx.$t('Compatibility.CompatibilityRequest.FirstName')), 1),
              _hoisted_34,
              _createElementVNode("div", _hoisted_35, _toDisplayString(_ctx.$t('Compatibility.CompatibilityRequest.LastName')), 1)
            ])
          ]),
          _createElementVNode("div", _hoisted_36, [
            _createElementVNode("div", _hoisted_37, [
              _withDirectives(_createElementVNode("input", {
                type: "text",
                class: "col inputCSS",
                "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.text) = $event))
              }, null, 512), [
                [_vModelText, _ctx.text]
              ]),
              _hoisted_38,
              _withDirectives(_createElementVNode("input", {
                type: "text",
                class: "col inputCSS",
                "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.text) = $event))
              }, null, 512), [
                [_vModelText, _ctx.text]
              ])
            ])
          ])
        ])
      ]),
      _hoisted_39
    ]),
    _createElementVNode("div", _hoisted_40, [
      _hoisted_41,
      _createElementVNode("div", _hoisted_42, [
        _createElementVNode("div", _hoisted_43, [
          _createElementVNode("div", _hoisted_44, _toDisplayString(_ctx.$t('Compatibility.CompatibilityRequest.Street')), 1),
          _createElementVNode("div", _hoisted_45, [
            _withDirectives(_createElementVNode("input", {
              class: "inputCSS",
              type: "text",
              "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.text) = $event))
            }, null, 512), [
              [_vModelText, _ctx.text]
            ])
          ])
        ])
      ]),
      _hoisted_46
    ]),
    _createElementVNode("div", _hoisted_47, [
      _hoisted_48,
      _createElementVNode("div", _hoisted_49, [
        _createElementVNode("div", _hoisted_50, [
          _createElementVNode("div", _hoisted_51, [
            _createElementVNode("div", _hoisted_52, [
              _createElementVNode("div", _hoisted_53, _toDisplayString(_ctx.$t('Compatibility.CompatibilityRequest.PLZ')), 1),
              _hoisted_54,
              _createElementVNode("div", _hoisted_55, _toDisplayString(_ctx.$t('Compatibility.CompatibilityRequest.Location')), 1)
            ])
          ]),
          _createElementVNode("div", _hoisted_56, [
            _createElementVNode("div", _hoisted_57, [
              _withDirectives(_createElementVNode("input", {
                type: "text",
                class: "col inputCSS",
                filled: "",
                "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((_ctx.text) = $event))
              }, null, 512), [
                [_vModelText, _ctx.text]
              ]),
              _hoisted_58,
              _withDirectives(_createElementVNode("input", {
                type: "text",
                class: "col inputCSS",
                filled: "",
                "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((_ctx.text) = $event))
              }, null, 512), [
                [_vModelText, _ctx.text]
              ])
            ])
          ])
        ])
      ]),
      _hoisted_59
    ]),
    _createElementVNode("div", _hoisted_60, [
      _hoisted_61,
      _createElementVNode("div", _hoisted_62, [
        _createElementVNode("div", _hoisted_63, [
          _createElementVNode("div", _hoisted_64, _toDisplayString(_ctx.$t('Compatibility.CompatibilityRequest.PositionOrFunction')), 1),
          _createElementVNode("div", _hoisted_65, [
            _withDirectives(_createElementVNode("input", {
              class: "inputCSS",
              type: "text",
              "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => ((_ctx.text) = $event))
            }, null, 512), [
              [_vModelText, _ctx.text]
            ])
          ])
        ])
      ]),
      _hoisted_66
    ]),
    _createElementVNode("div", _hoisted_67, [
      _hoisted_68,
      _createElementVNode("div", _hoisted_69, [
        _createElementVNode("div", _hoisted_70, [
          _createElementVNode("div", _hoisted_71, _toDisplayString(_ctx.$t('Compatibility.CompatibilityRequest.EmailAddress')), 1),
          _createElementVNode("div", _hoisted_72, [
            _withDirectives(_createElementVNode("input", {
              class: "inputCSS",
              type: "text",
              "onUpdate:modelValue": _cache[6] || (_cache[6] = ($event: any) => ((_ctx.text) = $event))
            }, null, 512), [
              [_vModelText, _ctx.text]
            ])
          ])
        ])
      ]),
      _hoisted_73
    ]),
    _createElementVNode("div", _hoisted_74, [
      _hoisted_75,
      _createElementVNode("div", _hoisted_76, [
        _createElementVNode("div", _hoisted_77, [
          _createElementVNode("div", _hoisted_78, _toDisplayString(_ctx.$t('Compatibility.CompatibilityRequest.Comment')), 1),
          _createElementVNode("div", _hoisted_79, [
            _withDirectives(_createElementVNode("input", {
              class: "inputCSS",
              type: "text",
              "onUpdate:modelValue": _cache[7] || (_cache[7] = ($event: any) => ((_ctx.text) = $event))
            }, null, 512), [
              [_vModelText, _ctx.text]
            ])
          ])
        ])
      ]),
      _hoisted_80
    ])
  ]))
}